<template>
	<!-- PARAGRAPHE -->
	<section :class="`paragraphe paragraphe-${paragraphe.type} background-${paragraphe.color}`">
		<!-- IMAGER -->
		<div v-if="paragraphe.type === 'imager'" class="container">
			<div v-if="paragraphe.imageDirection === 'droite'" class="row">
				<div class="col-xs-12 col-lg-7 col-left wow fadeInLeft">
					<h2>{{paragraphe.title}}</h2>

					<p v-html="paragraphe.body"></p>
					<LinkButton v-if="paragraphe.link" :link="paragraphe.link" />
				</div>
				<div class="col-xs-12 col-lg-5 col-right wow fadeInRight">
					<img :src="`/image/paragraphe/${paragraphe.image}`" class="img-fluid" />
				</div>
			</div>
			<div v-else class="row">
				<div class="col-xs-12 col-lg-5 col-left wow fadeInLeft">
					<img :src="`/image/paragraphe/${paragraphe.image}`" class="img-fluid" />
				</div>
				<div class="col-xs-12 col-lg-7 col-right wow fadeInRight">
					<h2>{{paragraphe.title}}</h2>
					<p v-html="paragraphe.body"></p>
					<LinkButton v-if="paragraphe.link" :link="paragraphe.link" />
				</div>
			</div>
		</div>
		<!-- LISTER -->
		<div v-else-if="paragraphe.type === 'lister'" class="container-fluid">
			<h2>{{paragraphe.title}}</h2>
			<p v-html="paragraphe.body"></p>
			<div class="item-wrapper">
				<div
					v-for="(component, i) in paragraphe.components"
					:key="i"
					:class="`node teaser ${component.type} wow fadeInUp`"
					:data-wow-delay="`${i * 0.15}s`"
				>
					<img
						:src="component.type === 'realisation' ? 
							`image/realisation/${Array.isArray(component.image) ? 
								component.image[0] 
								: component.image}` 
							: `image/${component.image}`"
						class="img-fluid"
					/>
					<router-link :to="`/realisation/${component.id}`">
						<span v-if="component.type === 'category'">{{component.menuTitle}}</span>
						<span v-else class="hidden">{{component.title}}</span>
					</router-link>
				</div>
			</div>
			<LinkButton v-if="paragraphe.link" :link="paragraphe.link" />
		</div>
		<!-- VITRINE -->
		<div v-else-if="paragraphe.type === 'vitrine'" class="container">
			<h2>{{paragraphe.title}}</h2>
			<p v-html="paragraphe.body"></p>
			<div class="item-wrapper">
				<div
					v-for="(item, i) in paragraphe.items"
					:key="i"
					class="item wow fadeInUp"
					:data-wow-delay="`${i * 0.15}s`"
				>
					<img :src="`image/${item.image}`" class="img-fluid" />
					<p v-if="item.title !== 'undefined'">{{item.title}}</p>
				</div>
			</div>
			<LinkButton v-if="paragraphe.link" :link="paragraphe.link" />
		</div>
		<!-- DEFAUT -->
		<div v-else class="container-fluid">
			<h2>{{paragraphe.title}}</h2>
			<p v-html="paragraphe.body"></p>
			<LinkButton v-if="paragraphe.link" :link="paragraphe.link" />
		</div>
	</section>
</template>

<script>
//data
import Paragraphe from "../data-schema/Paragraphe.js";
//component
import LinkButton from "../component/LinkButton.vue";

export default {
	name: "Section",
	props: {
		paragraphe: {
			type: Paragraphe,
			required: true
		}
	},
	components: {
		LinkButton
	}
};
</script>
